import { render, staticRenderFns } from "./IconAddToCalendar.vue?vue&type=template&id=0671604c&"
import script from "./IconAddToCalendar.vue?vue&type=script&lang=js&"
export * from "./IconAddToCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports